// eslint-disable-next-line import/prefer-default-export
export const goToError = (selector) => {
  const goToErrorSelector = selector || '.has-error';
  const elements = document.querySelectorAll(goToErrorSelector);
  if (elements.length) {
    elements.item(0).scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }
};



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/utils/Utils.js